export default function ConvertTime(timestamp) {
  if (!timestamp) {
    console.warn("ConvertTime received an invalid timestamp:", timestamp);
    return "Invalid timestamp";
  }

  const [datePart, timePart] = timestamp.split('T');
  const [year, month, day] = datePart.split('-');
  const [hours, minutes] = timePart.split(':');

  return `${hours}:${minutes} ${month}/${day}/${year}`;
}

